export const LOAD_INVENTORY = 'LOAD_INVENTORY'
export const LOAD_INVENTORY_SUCCESS = 'LOAD_INVENTORY_SUCCESS'
export const LOAD_INVENTORY_FAILURE = 'LOAD_INVENTORY_FAILURE'

export const ADD_INVENTORY_BY_CITY_ID = 'ADD_INVENTORY_BY_CITY_ID'

export const ADD_INVENTORY_ITEM = 'ADD_INVENTORY_ITEM'
export const ADD_INVENTORY_ITEM_SUCCESS = 'ADD_INVENTORY_ITEM_SUCCESS'
export const ADD_INVENTORY_ITEM_FAILURE = 'ADD_INVENTORY_ITEM_FAILURE'

export const ADD_INVENTORIES_BY_CITY_ID_ALL = 'ADD_INVENTORIES_BY_CITY_ID_ALL'
export const ADD_INVENTORIES_BY_CITY_ID_ALL_SUCCESS =
  'ADD_INVENTORIES_BY_CITY_ID_ALL_SUCCESS'

export const EDIT_INVENTORY_ALL = 'EDIT_INVENTORY_ALL'
export const EDIT_INVENTORY_ALL_SUCCESS = 'EDIT_INVENTORY_IN_PARALLEL_SUCCESS'

export const GET_INVENTORY_TYPES = 'GET_INVENTORY_TYPES'
export const GET_INVENTORY_TYPES_SUCCESS = 'GET_INVENTORY_TYPES_SUCCESS'

export const EDIT_INVENTORY = 'EDIT_INVENTORY'

export const FORM_NAMES = {
  MOVE_INVENTORY_FORM: 'moveInventoryForm',
  EDIT_INVENTORY_FORM: 'editInventoryForm',
}

export const SIZE_AND_QUANTITY_OPTIONS = [
  { label: 'N/A', value: 'N/A' },
  { label: 'XS', value: 'XS' },
  { label: 'S', value: 'S' },
  { label: 'M', value: 'M' },
  { label: 'L', value: 'L' },
  { label: 'XL', value: 'XL' },
  { label: 'XXL', value: 'XXL' },
  { label: 'XXXL', value: 'XXXL' },
  { label: 'XXXXL', value: 'XXXXL' },
]

export const INVENTORY_MOVEMENT_TYPE = {
  INIT: 'INIT',
  OUT: 'OUT',
  IN: 'IN',
}

export const MOVE_INVENTORY = 'MOVE_INVENTORY'
export const MOVE_INVENTORY_SUCCESS = 'MOVE_INVENTORY_SUCCESS'
export const MOVE_INVENTORY_FAILURE = 'MOVE_INVENTORY_FAILURE'

export const ADD_FLYER_CODES = 'ADD_FLYER_CODES'
export const ADD_FLYER_CODES_SUCCESS = 'ADD_FLYER_CODES_SUCCESS'
export const ADD_FLYER_CODES_FAILURE = 'ADD_FLYER_CODES_FAILURE'

export const GET_INVENTORY_ITEM = 'GET_INVENTORY_ITEM'
export const GET_INVENTORY_ITEM_SUCCESS = 'GET_INVENTORY_ITEM_SUCCESS'
export const GET_INVENTORY_ITEM_FAILURE = 'GET_INVENTORY_ITEM_FAILURE'

export const DELETE_FLYER_CODE = 'DELETE_FLYER_CODE'
export const DELETE_FLYER_CODE_SUCCESS = 'DELETE_FLYER_CODE_SUCCESS'
export const DELETE_FLYER_CODE_FAILURE = 'DELETE_FLYER_CODE_FAILURE'
